export default __webpack_public_path__ + "static/media/SWT0640.34I-35722_-20838_0.cace5759.jpg";